import { render } from "./QuickRegister.vue?vue&type=template&id=68256426&scoped=true"
import script from "./QuickRegister.vue?vue&type=script&lang=js"
export * from "./QuickRegister.vue?vue&type=script&lang=js"

import "./QuickRegister.vue?vue&type=style&index=0&id=68256426&scoped=true&lang=css"
import "./QuickRegister.vue?vue&type=style&index=1&id=68256426&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68256426"]])

export default __exports__